import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChatwootService } from '../../services/chatwoot.service';
import { getSentry, getSentryErrorsQueryUrl } from '../../../../core/utils';

export enum MessageType {
  Error,
  Info,
  Success,
  Warning,
}

export type Message = string | { key: string; params: Record<string, string> };

export interface AlertDialogInput {
  message: Message;
  type: MessageType;
  details?: string;
}

export type AlertDialogResult = undefined;

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
  standalone: false,
})
export class AlertDialogComponent {
  private readonly sentryLastEventId: string | undefined;

  protected readonly MessageType = MessageType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: AlertDialogInput,
    private readonly dialogRef: MatDialogRef<AlertDialogComponent, AlertDialogResult>,
    private readonly chatwoot: ChatwootService,
  ) {
    this.sentryLastEventId = getSentry()?.lastEventId();
  }

  protected ok(): void {
    this.dialogRef.close();
  }

  protected async report(): Promise<void> {
    this.chatwoot.run((cw) => {
      if (this.sentryLastEventId) {
        cw.setConversationCustomAttributes({
          sentry_last_error: getSentryErrorsQueryUrl(this.sentryLastEventId),
        });
      }

      cw.toggle('open');
    });
  }
}
